import React, { useEffect, useState } from 'react';
import { Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import {
  customerType,
  isValidNumber,
  unitCaseEnum,
} from '../../utils/settings';
import Form from 'antd/es/form';
import { GetAllCityOfState } from '../../screen/auth/action/util_actions';
import { useLocation, useNavigate } from 'react-router-dom';
import Screenback from '../../components/screenBack/screenBack';
import FmcgProdCard from '../Components/FmcgProdCard';
import CheckoutConfirmationModal from '../Components/CheckoutConfirmationModal';
import {
  AddDistributorSellInvoice,
  sellProductWithProductCompanyIdAction,
} from '../../screen/distributor/action/util_action';
import {
  Box,
  Container,
  Grid,
  Stack,
  TextField,
  ToggleButtonGroup,
  Button,
  Card,
  CardHeader,
  CardContent,
  ToggleButton,
  IconButton,
  Typography,
} from '@mui/material';
import { toast } from 'react-toastify';
import { Add, DeleteOutline, Edit } from '@mui/icons-material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import dayjs from 'dayjs';

const CartViewController = () => {
  const [distArr, setDistArr] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { state } = useLocation();

  const [selectedCompany, setSelectedCompany] = useState(
    state?.selectedCompany || {},
  );
  const toggleButtonlist = [
    { value: 0, label: state?.selectedCompany?.allocable_quantity?.unit },
    {
      value: 1,
      label: state?.selectedCompany?.allocable_quantity?.base_unit,
    },
  ];
  const [sellQty, setSellQty] = useState();
  const [alignment, setAlignment] = useState(0);
  const handleAlignment = (event, newAlignment) => {
    if (newAlignment !== null) {
      setAlignment(newAlignment);
    }
  };
  const [invoiceNumber, setInvoiceNumber] = useState('');
  const [invoiceDate, setInvoiceDate] = useState(dayjs().format('YYYY-MM-DD'));

  const {
    loginUser,
    deliveryAddressDetails,
    cartItemList,
    retailers,
    unitCaseWise,
    selectedStp,
    seller_id,
  } = useSelector((state) => {
    return {
      loginUser: state.loginReducer.loginUser,
      cart: state.orderReducer.cart,
      deliveryAddressDetails: state.orderReducer.deliveryAddressDetails,
      company_id: state.orderReducer.company_id,
      distributor: state.orderReducer.distributor,
      cartItemList: state.fmcgReducer.cartItemList,
      unitCaseWise: state.fmcgReducer.unitCaseWise,
      retailers: state.orderReducer.retailers,
      selectedStp: state.bcmOrderReducer.selectedStp,
      seller_id: state.bcmOrderReducer.seller_id,
    };
  });

  const productListComponent = () => {
    return (
      <Card
        sx={{
          mb: 2,
          borderRadius: '5px',
        }}
      >
        <CardHeader
          title={
            <Typography
              variant='subtitle1'
              fontWeight='bold'
              color='#637381'
            >
              {selectedCompany.is_inventory_homogeneous
                ? 'Enter Quantity To Sell'
                : 'Products'}
            </Typography>
          }
          action={
            !selectedCompany?.is_inventory_homogeneous && (
              <Tooltip title='Add More Products to Sell'>
                <IconButton
                  onClick={() => {
                    navigate(`/distributor/inventory`, {
                      state: {
                        companyId: seller_id,
                        isFromSelltoBuyer: true,
                      },
                    });
                  }}
                  sx={{ color: '#F49D3F' }}
                >
                  <Add />
                </IconButton>
              </Tooltip>
            )
          }
          sx={{ backgroundColor: '#f4f6f8', px: 2, py: 1 }}
        />
        <CardContent>
          <Box sx={{ padding: { xs: 0, sm: 2 } }}>
            {selectedCompany.is_inventory_homogeneous ? (
              <Box>
                <Grid
                  container
                  spacing={2}
                  alignItems='center'
                >
                  <Grid
                    item
                    xs={12}
                    sm={8}
                    md={9}
                    container
                    alignItems='center'
                    spacing={2}
                  >
                    <Grid item>
                      <Typography variant='h6'>Available Quantity</Typography>
                    </Grid>
                    <Grid item>
                      <Typography variant='h6'>
                        {alignment
                          ? `${selectedCompany?.allocable_quantity?.quantity_in_bags} ${selectedCompany.allocable_quantity.base_unit}`
                          : `${selectedCompany?.allocable_quantity?.quantity_in_metric_ton} ${selectedCompany.allocable_quantity.unit}`}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={4}
                    md={3}
                    container
                    justifyContent={{ xs: 'flex-start', sm: 'flex-end' }}
                  >
                    <ToggleButtonGroup
                      value={alignment}
                      exclusive
                      onChange={handleAlignment}
                      aria-label='text alignment'
                    >
                      {toggleButtonlist.map((toggleButton) => (
                        <ToggleButton
                          key={toggleButton.value}
                          value={toggleButton.value}
                          aria-label={toggleButton.value}
                        >
                          {toggleButton.label}
                        </ToggleButton>
                      ))}
                    </ToggleButtonGroup>
                  </Grid>
                </Grid>
                <TextField
                  margin='normal'
                  fullWidth
                  id='sellquantity'
                  label='Sell Quantity'
                  name='sellquantity'
                  value={sellQty}
                  onChange={(e) => setSellQty(e.target.value)}
                />
              </Box>
            ) : (
              <Box>
                {cartItemList.map((prod, index) => (
                  <FmcgProdCard
                    key={index}
                    prod={prod}
                    index={index}
                    itemInCart={prod}
                  />
                ))}
              </Box>
            )}
          </Box>
        </CardContent>
      </Card>
    );
  };

  useEffect(() => {
    const addressDetails = {
      deliveryAddress: loginUser?.company_details?.address,
      deliveryPincode: loginUser?.company_details?.pincode,
      requestedDistrictId: {
        label: loginUser?.company_details?.district_id.district_name,
        value: loginUser?.company_details?.district_id?.id,
      },
    };
    dispatch({
      type: 'SAVE_ADDRESS',
      address: addressDetails,
    });
  }, [loginUser]);

  const adressAndCartView = () => {
    return (
      <div>
        <div>{deliveryAddressComponent()}</div>
        <div>{cartTotalComponent()}</div>
      </div>
    );
  };
  const getDistrictOptions = () => {
    return distArr.length > 0
      ? distArr.map((district) => ({
          label: district.district_name,
          value: district.id,
        }))
      : [];
  };

  const getAllCityOfState = async (stateId) => {
    if (stateId >= 0) {
      await GetAllCityOfState(stateId)
        .then((districts) => {
          setDistArr(districts);
          let { error, data } = districts;
          if (!error && data) {
            setDistArr(data);
          }
        })
        .catch();
    }
  };

  useEffect(() => {
    if (loginUser?.company_details?.district_id?.state.id) {
      getAllCityOfState(loginUser?.company_details?.district_id?.state.id);
    }
  }, [loginUser]);

  const cartTotalComponent = () => {
    return (
      <Card
        sx={{
          mb: 2,
          borderRadius: '5px',
        }}
      >
        <CardHeader
          title={
            <Typography
              variant='subtitle1'
              fontWeight='bold'
              color='#637381'
            >
              Checkout
            </Typography>
          }
          sx={{ backgroundColor: '#f4f6f8', px: 2, py: 1 }}
        />
        <CardContent>
          <Stack
            direction='column'
            spacing={2}
            alignItems='center'
          >
            {/* Invoice Number */}
            <TextField
              fullWidth
              id='invoice_number'
              label='Invoice Number'
              name='invoice_number'
              autoComplete='invoice_number'
              autoFocus
              value={invoiceNumber}
              onChange={(e) => setInvoiceNumber(e.target.value)}
            />

            {/* Invoice Date */}
            <TextField
              fullWidth
              label='Invoice Date'
              id='invoice_date'
              name='invoice_date'
              type='date'
              value={invoiceDate}
              onChange={(e) => setInvoiceDate(e.target.value)}
              inputProps={{
                max: dayjs().format('YYYY-MM-DD'),
                min: dayjs().subtract(14, 'day').format('YYYY-MM-DD')
              }}
            />

            {/* Checkout Button */}
            <Button
              variant='contained'
              color='warning'
              fullWidth
              sx={{
                height: 50,
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              disabled={loading}
              onClick={
                selectedCompany.is_inventory_homogeneous
                  ? handleQuantityCheckoutClick
                  : handleCheckoutClick
              }
            >
              Proceed to Checkout
            </Button>
          </Stack>
        </CardContent>
      </Card>
    );
  };

  const validateCheckout = () => {
    if (Object.keys(selectedStp).length === 0) {
      toast.error('Please add Delivery Address');
      return false;
    }
    if (cartItemList.length === 0) {
      toast.error('Please add Products to cart');
      return false;
    }
    if (!invoiceDate) {
      toast.error('Please select Invoice Date');
      return false;
    }
    return true;
  };

  const handleCheckoutClick = () => {
    if (!validateCheckout()) return;
    setPendingAction('checkout');
    setShowConfirmModal(true);
  };

  const onCheckOut = async () => {
    const newPayload = {
      products: cartItemList.map((prod) => {
        const sellQty = prod.sellToBuyerQty.qty;
        return {
          product_id: prod.product_info.product_id,
          quantity: {
            quantity_in_bags:
              (unitCaseWise === unitCaseEnum['UNIT'] && sellQty) || null,
            quantity_in_metric_ton:
              (unitCaseWise === unitCaseEnum['CASE'] && sellQty) || null,
            multiplier: prod.allocable_quantity.multiplier,
            unit: prod.allocable_quantity.unit,
            base_unit: prod.allocable_quantity.base_unit,
          },
          deliver_to: selectedStp.company_id,
          price_per_unit: 0,
          gst_amount: 0,
          total_amount: 0,
          product_gst_percentage: 0,
        };
      }),
      invoice_no: invoiceNumber,
      invoice_files_base64: [],
      date_of_invoice: dayjs(invoiceDate).format('YYYY-MM-DD'),
    };

    setLoading(true);

    const { error, message } = await AddDistributorSellInvoice(newPayload);

    setLoading(false);

    if (!error) {
      dispatch({ type: 'RESET_FMCG_REDUCER' });
      dispatch({ type: 'CLEAR_RETAILERS' });
      dispatch({ type: 'RESET_BCM_ORDER' });
      return navigate('/fmcg/order-completed', { replace: true });
    } else {
      toast.error(message);
    }
  };

  const validateQuantityCheckout = () => {
    if (Object.keys(selectedStp).length === 0) {
      toast.error('Please add Delivery Address');
      return false;
    }
    if (!sellQty) {
      toast.error('Please add sell quantity');
      return false;
    }
    if (!isValidNumber(sellQty)) {
      toast.error('Please add valid sell quantity');
      return false;
    }
    if (!invoiceNumber.trim()) {
      toast.error('Please enter Invoice Number');
      return false;
    }
    if (!invoiceDate) {
      toast.error('Please select Invoice Date');
      return false;
    }
    return true;
  };

  const handleQuantityCheckoutClick = () => {
    if (!validateQuantityCheckout()) return;
    setPendingAction('quantity');
    setShowConfirmModal(true);
  };

  const onSellByQuantity = async () => {
    const payload = {
      product_company_id: selectedCompany.company_id,
      quantity: {
        quantity_in_bags: alignment ? Number(sellQty) : null,
        quantity_in_metric_ton: alignment ? null : Number(sellQty),
        multiplier: 1000,
        unit: selectedCompany.allocable_quantity.unit,
        base_unit: selectedCompany.allocable_quantity.base_unit,
      },
      price_per_unit: 0,
      discount: 0,
      tax_amount: 0,
      total_amount: 0,
      invoice_no: invoiceNumber,
      buy_or_sell_to: selectedStp.company_id,
      invoice_files_base64: [],
      date_of_invoice: dayjs(invoiceDate).format('YYYY-MM-DD'),
    };

    const { error, message } = await sellProductWithProductCompanyIdAction(
      payload,
    );

    if (!error) {
      return navigate('/fmcg/order-completed', { replace: true });
    } else {
      toast.error(message);
    }
  };

  const handleConfirmCheckout = async () => {
    setShowConfirmModal(false);
    if (pendingAction === 'checkout') {
      await onCheckOut();
    } else if (pendingAction === 'quantity') {
      await onSellByQuantity();
    }
  };

  const handleCancelModal = () => {
    setShowConfirmModal(false);
    setPendingAction(null);
  };

  const getModalData = () => {
    const isHomogeneous = selectedCompany.is_inventory_homogeneous;

    return {
      deliveryDetails: {
        ...selectedStp,
        ...(retailers.length > 0 && retailers[0]),
      },
      productDetails: isHomogeneous
        ? {
            availableQty: alignment
              ? `${selectedCompany?.allocable_quantity?.quantity_in_bags} ${selectedCompany.allocable_quantity.base_unit}`
              : `${selectedCompany?.allocable_quantity?.quantity_in_metric_ton} ${selectedCompany.allocable_quantity.unit}`,
            sellQty: `${sellQty} ${
              alignment
                ? selectedCompany.allocable_quantity.base_unit
                : selectedCompany.allocable_quantity.unit
            }`,
          }
        : {
            products: cartItemList,
          },
      invoiceDetails: {
        invoiceNumber,
        invoiceDate,
      },
      isHomogeneous,
    };
  };

  function clearRetailer() {
    dispatch({
      type: 'SET_SELECTED_STP',
      data: {},
    });
    dispatch({ type: 'CLEAR_RETAILERS' });
  }

  const deliveryAddressComponent = () => {
    return (
      <Card sx={{ mb: 2, borderRadius: '5px' }}>
        <CardHeader
          title={
            <Typography
              variant='subtitle1'
              fontWeight='bold'
              color='#637381'
            >
              Deliver To
            </Typography>
          }
          sx={{ backgroundColor: '#f4f6f8', px: 2, py: 1 }}
          action={
            Object.keys(selectedStp).length > 0 ? (
              <Stack
                direction='row'
                spacing={1}
              >
                <Tooltip title='Remove Retailer'>
                  <IconButton
                    onClick={clearRetailer}
                    sx={{ color: '#F49D3F' }}
                  >
                    <DeleteOutline />
                  </IconButton>
                </Tooltip>
                <Tooltip title='Edit Retailer'>
                  <IconButton
                    onClick={() => {
                      navigate('/order-booking/ship-to-party-details', {
                        state: {
                          buyerDetails: selectedStp,
                          isFromEditOrderDetails: false,
                          isSellToBuyer: true,
                          isEditingSelectedStp: true,
                        },
                      });
                    }}
                    sx={{ color: '#F49D3F' }}
                  >
                    <Edit />
                  </IconButton>
                </Tooltip>
              </Stack>
            ) : (
              <Tooltip title='Add Retailer'>
                <IconButton
                  onClick={() => {
                    dispatch({
                      type: 'ADD_USER_DATA',
                      data: {
                        buyerId: customerType['DEALER'],
                        fromOrderDetails: false,
                        editUserData: {},
                      },
                    });

                    navigate('/order-booking/select-ship-to-party', {
                      state: { fromFmcgCart: true },
                    });
                  }}
                  sx={{ color: '#F49D3F' }}
                >
                  <Add />
                </IconButton>
              </Tooltip>
            )
          }
        />
        <CardContent>
          <Grid
            container
            spacing={1}
          >
            {[
              { label: 'Firm Name:', key: 'company_name' },
              { label: 'Phone Number:', key: 'company_phone_no' },
              { label: 'Address:', key: 'company_address', isAddress: true },
            ]
              .filter((item) => {
                if (item.isAddress) {
                  return (
                    selectedStp.delivery_Address_line1 ||
                    selectedStp.delivery_Address_line2
                  );
                }
                return selectedStp[item.key];
              })
              .map((item) => (
                <Grid
                  container
                  key={item.key}
                  alignItems='center'
                  sx={{ mb: 1 }}
                >
                  <Grid
                    item
                    xs={5}
                  >
                    <Typography
                      variant='body2'
                      fontWeight='bold'
                    >
                      {item.label}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={7}
                  >
                    <Typography variant='body2'>
                      {item.isAddress
                        ? `${selectedStp.delivery_Address_line1 || ''}, ${
                            selectedStp.delivery_Address_line2 || ''
                          }`
                        : selectedStp[item.key]}
                    </Typography>
                  </Grid>
                </Grid>
              ))}

            {retailers.length > 0 && (
              <>
                {[
                  { label: 'Firm Name:', key: 'firm_name' },
                  { label: 'Delivery Address:', key: 'address' },
                  { label: 'Phone Number:', key: 'retailor_phone' },
                  { label: 'GSTIN:', key: 'company_gstin' },
                  { label: 'PAN:', key: 'pancard_no' },
                ]
                  .filter((item) => retailers[0][item.key])
                  .map((item) => (
                    <Grid
                      container
                      key={item.key}
                      alignItems='center'
                      sx={{ mb: 1 }}
                    >
                      <Grid
                        item
                        xs={5}
                      >
                        <Typography
                          variant='body2'
                          fontWeight='bold'
                        >
                          {item.label}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={7}
                      >
                        <Typography variant='body2'>
                          {retailers[0][item.key]}
                        </Typography>
                      </Grid>
                    </Grid>
                  ))}
              </>
            )}
          </Grid>
        </CardContent>
      </Card>
    );
  };

  return (
    <Container
      maxWidth='true'
      sx={{ pl: '1rem', py: '2rem' }}
    >
      <Grid
        container
        spacing={{ xs: 0, sm: 3 }}
        justifyContent='center'
        sx={{ width: '100%' }}
      >
        <Grid
          item
          xs={12}
          lg={8}
        >
          {productListComponent()}
        </Grid>
        <Grid
          item
          xs={12}
          lg={4}
        >
          {adressAndCartView()}
        </Grid>
      </Grid>

      <CheckoutConfirmationModal
        open={showConfirmModal}
        onClose={handleCancelModal}
        onConfirm={handleConfirmCheckout}
        loading={loading}
        {...getModalData()}
      />
    </Container>
  );
};

export default CartViewController;
